import SectionHeading from "@/components/base/SectionHeading";
import { workflowSteps } from "@/mocks/site";

export default function WorkflowSection() {
  return (
    <section className="py-14 md:py-20 bg-background-100 border-y border-background-200">
      <div className="max-w-shell mx-auto px-4 md:px-6">
        <SectionHeading
          eyebrow="Editorial Flow"
          title="一条时间线是怎么做出来的"
          desc="从收到线索到写进时间线，每条进展都会经过以下四个环节再发布。"
        />
        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {workflowSteps.map((item) => (
            <article
              key={item.step}
              className="relative flex flex-col gap-3 p-6 rounded-lg bg-background-50 border border-background-200"
            >
              <span className="font-heading text-3xl font-black text-accent-500">{item.step}</span>
              <h3 className="font-heading text-base font-bold text-foreground-950">{item.title}</h3>
              <p className="text-sm leading-relaxed text-foreground-600">{item.desc}</p>
              <span className="absolute top-6 right-6 w-8 h-8 flex items-center justify-center text-background-300">
                <i className="ri-arrow-right-line" />
              </span>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}